export function tramitesPage() {
    return {
        tramites: { registro: [], licencia: [] },
        filtrados: [],
        filtro: 'registro',
        selected: 0,
        selectedSlug: null,
        searchQuery: '',
        onlyWithLinks: false,
        loading: false,
        dataUrl: '',
        emptyCategoria: '',
        defaultEmptyTitle: '',
        defaultEmptyText: '',
        errorLoading: '',
        resultsSuffix: '',
        requirementsTitle: '',
        requirementNumber: '',
        requirementName: '',
        linksTitle: '',

        async fetchTramites() {
            this.loading = true;
            try {
                const res = await fetch(this.dataUrl);
                if (!res.ok) throw new Error(this.errorLoading || 'Error');
                const data = await res.json();
                this.tramites = data;
                this.aplicarFiltro();
            } catch (error) {
                console.error('Error fetching tramites:', error);
                this.showError(this.errorLoading || 'Error');
            } finally {
                this.loading = false;
            }
        },

        filtrar(tipo) {
            this.filtro = tipo;
            this.aplicarFiltro();
            this.scrollToContent();
        },

        normalizarTexto(texto) {
            return (texto || '')
                .toString()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^\w\s]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
                .toLowerCase();
        },

        toggleOnlyWithLinks() {
            this.onlyWithLinks = !this.onlyWithLinks;
            this.aplicarFiltro();
        },

        limpiarBusqueda() {
            this.searchQuery = '';
            this.aplicarFiltro();
        },

        selectTramite(index) {
            this.selected = index;
            this.selectedSlug = this.filtrados[index]?.slug || null;
            this.scrollToContent();
        },

        aplicarFiltro() {
            const base = this.tramites[this.filtro] || [];
            const query = this.normalizarTexto(this.searchQuery);
            const terms = query ? query.split(' ').filter(Boolean) : [];

            this.filtrados = base.filter((tramite) => {
                if (this.onlyWithLinks && !(tramite.enlaces && tramite.enlaces.length > 0)) {
                    return false;
                }

                if (!terms.length) return true;

                const haystack = this.normalizarTexto([
                    tramite.slug,
                    tramite.nombre,
                    tramite.descripcion,
                    (tramite.requisitos || []).join(' ')
                ].join(' '));

                return terms.every((term) => haystack.includes(term));
            });

            if (!this.filtrados.length) {
                this.selected = 0;
                this.selectedSlug = null;
                return;
            }

            const indexBySlug = this.selectedSlug
                ? this.filtrados.findIndex((tramite) => tramite.slug === this.selectedSlug)
                : -1;

            this.selected = indexBySlug >= 0 ? indexBySlug : 0;
            this.selectedSlug = this.filtrados[this.selected]?.slug || null;
        },

        get selectedTramite() {
            return this.filtrados[this.selected] || null;
        },

        scrollToContent() {
            setTimeout(() => {
                const element = document.getElementById('tramite-content');
                if (element && window.innerWidth <= 768) {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }, 100);
        },

        showError(message) {
            console.error(message);
        },

        init() {
            const ds = this.$root.dataset;
            this.dataUrl = ds.dataUrl || '';
            this.emptyCategoria = ds.emptyCategoria || '';
            this.defaultEmptyTitle = ds.defaultEmptyTitle || '';
            this.defaultEmptyText = ds.defaultEmptyText || '';
            this.errorLoading = ds.errorLoading || '';
            this.resultsSuffix = ds.resultsSuffix || '';
            this.requirementsTitle = ds.requirementsTitle || '';
            this.requirementNumber = ds.requirementNumber || '';
            this.requirementName = ds.requirementName || '';
            this.linksTitle = ds.linksTitle || '';
            this.fetchTramites();
        }
    }
}
